// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import { FormValidator } from '../../../../../utils/form/index';

import style from '../EditProfile.scss';
import commonStyle from '../../../PreferencesViewCommon.scss';
import buttonStyle from '../../../../../assets/styles/button.scss';
import inputStyle from '../../../../../assets/styles/input.scss';
import formStyle from '../../../../../assets/styles/form.scss';

type Props = {
  +firstName: { [key: string]: any };
  +lastName: { [key: string]: any };
  +handleChange: (e: Event) => void;
  +handleFocus: (e: Event) => void;
  +handleBlur: (e: Event) => void;
  +isDataPristine: () => boolean;
  +handleDataSubmit: (e: Event) => void;
  +isPutting?: boolean;
};

const messages = defineMessages({
  firstName: {
    label: {
      id: 'address.firstName.label',
    },
    placeholder: {
      id: 'address.firstName.placeholder',
    },
  },
  lastName: {
    label: {
      id: 'address.lastName.label',
    },
    placeholder: {
      id: 'address.lastName.placeholder',
    },
  },
  button: {
    saveChange: {
      id: 'preferences.editProfile.saveChange',
    },
  },
});

export default class ImportantDataForm extends Component<Props> {

  render() {
    const {
      firstName, lastName, handleChange, handleFocus, handleBlur, isDataPristine,
      handleDataSubmit, isPutting,
    } = this.props;
    const firstNameError = firstName.errors && FormValidator.buildErrorLabel(firstName.errors, {
      required: 'address.firstName.error.required',
    });
    const lastNameError = lastName.errors && FormValidator.buildErrorLabel(lastName.errors, {
      required: 'address.lastName.error.required',
    });
    return (
      <form className={classNames(formStyle.formWrap, commonStyle.inputs, style.dataForm)}
            onSubmit={handleDataSubmit}>
        <section className={classNames(formStyle.row, formStyle.inputRow)}>
          <FormattedMessage id={messages.firstName.label.id}>{
            txt => (<label className={formStyle.label}>{txt}</label>)
          }</FormattedMessage>
          <input value={firstName.value}
                 className={classNames(inputStyle.input,
                   { [inputStyle.red]: firstName.errors && firstName.errors.length },
                   { [inputStyle.lightBlue]: !!firstName.value })}
                 onChange={handleChange}
                 onFocus={handleFocus}
                 onBlur={handleBlur}
                 disabled={isPutting}
                 name="firstName"
                 placeholder={this.context.intl.formatMessage(messages.firstName.placeholder)}/>
          {firstNameError}
        </section>
        <section className={classNames(formStyle.row, formStyle.inputRow)}>
          <FormattedMessage id={messages.lastName.label.id}>{
            txt => (<label className={formStyle.label}>{txt}</label>)
          }</FormattedMessage>
          <input
            className={classNames(inputStyle.input, { [inputStyle.red]: lastName.errors && lastName.errors.length },
              { [inputStyle.lightBlue]: !!lastName.value })}
            value={lastName.value}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            disabled={isPutting}
            name="lastName"
            placeholder={this.context.intl.formatMessage(messages.lastName.placeholder)}/>
          {lastNameError}
        </section>
        <section className={classNames(formStyle.row, formStyle.inputRow, commonStyle.button)}>
          <FormattedMessage id={messages.button.saveChange.id}>{
            txt =>
              <button type="submit"
                      disabled={isPutting || isDataPristine()}
                      className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
                      onClick={handleDataSubmit}>{txt}
              </button>
          }</FormattedMessage>
        </section>
      </form>
    );
  }
}

ImportantDataForm.propTypes = {
  firstName: PropTypes.object.isRequired,
  lastName: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  isDataPristine: PropTypes.func.isRequired,
  handleDataSubmit: PropTypes.func.isRequired,
  isPutting: PropTypes.bool,
};

ImportantDataForm.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/preferences/edit-profile/components/ImportantData/ImportantDataForm.jsx